export default __webpack_public_path__ + "static/header-devel-deec83f36103d0b142b45f37f39912a7.png";